import { DOMAIN_CURRENCY_MAP } from '@/src/constants/domainCurrencyMap'
import { CurrencyConfig, CurrencyConversion } from '@/src/types/currency'
import { getB2ECountryDomain } from '../generalUtils/getB2ECountryDomain'

export const formatCurrency = ({
    amount,
    currency,
    locale,
    precision,
    usePrecision = true
}: {
    amount: number
    currency: string
    locale: string
    precision: number
    usePrecision?: boolean
}): string => {
    try {
        let finalAmount = amount
        let formatOptions: Intl.NumberFormatOptions = {
            style: 'currency',
            currency
        }
        if (usePrecision) {
            formatOptions.minimumFractionDigits = precision
            formatOptions.maximumFractionDigits = precision
            finalAmount = precision === 0 ? parseInt(Math.ceil(amount).toString(), 10) : amount
        }

        return finalAmount.toLocaleString(locale, formatOptions)
    } catch (error) {
        // Fallback formatting if locale/currency is not supported
        if (!usePrecision) {
            return `${currency} ${amount.toString()}`
        }
        return `${currency} ${amount.toFixed(precision)}`
    }
}

export const getConversionRateDetails = (
    conversions: CurrencyConversion[],
    fromCurrency: string,
    toCurrency: string
) => {
    if (fromCurrency === toCurrency)
        return { from: fromCurrency, to: toCurrency, rate: 1, buffer: 0 } as CurrencyConversion

    const conversion = conversions.find(conv => conv.from === fromCurrency && conv.to === toCurrency)
    return conversion
}

export const getCurrencyByLocale = (): CurrencyConfig => {
    if (typeof window === 'undefined') {
        // Default for SSR
        return DOMAIN_CURRENCY_MAP['www.cleartrip.sa']
    }

    const domain = getB2ECountryDomain()

    return DOMAIN_CURRENCY_MAP[domain] || DOMAIN_CURRENCY_MAP['www.flyin.com']
}

// Encoding the utm_currency cookie value
export const encodingValue = (obj: string = ''): string => {
    return obj
        .split('')
        .map(char => char.charCodeAt(0))
        .join('-')
}

// Decoding the utm_currency cookie value
export const decodingValue = (obj: string): string => {
    const [value, encodedSymbols] = obj.split('|')
    const decodedSymbols =
        encodedSymbols
            ?.split('-')
            .map(code => String.fromCharCode(Number(code)))
            .join('') || ''
    return `${value}|${decodedSymbols}`
}
